export default {
  cardContainer: {
    boxShadow: "0px 0px 8px 0px rgba(0, 0, 0, 0.10)",
    padding: "20px 28px 20px 20px",
    marginLeft: "10px",
    marginRight: " 14px",
    borderRadius: "8px",
    minWidth: "390px",
    width: "100%",
    maxHeight: "447px",
  },
  rowContainer: {
    display: "flex",
    justifyContent: "space-between",
  },
  rowKey: {
    minWidth: "45%",
    paddingRight: "10px",
  },
  rowValue: {
    textAlign: "end",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  EditBtn: {
    alignItem: "center",
  },
  imgContainer: {
    textAlign: "center",
  },
  profileImage: {
    borderRadius: "82.5px",
    border: "3px solid #FFF",
    boxShadow: "4px 4px 8px 0px rgba(0, 0, 0, 0.25)",
    marginBottom: "8px",
  },
  button: {
    display: "flex",
    marginTop: "0.8rem",
    justifyContent: "center",
  },
  btnStyle: {
    padding: "0.4px 3rem",
    fontSize: 12,
    width: "min-content",
    height: "28px",
  },
  divider: {
    margin: "0.8rem -0.6rem",
  },
  imageView: {
    background: "#043D902E 0% 0% no-repeat padding-box",
    borderRadius: "50%",
    border: "3px solid #FFF",
    minWidth: "120px",
    minHeight: "120px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "100px",
    color: "#66697A",
    fontWight: "700",
    fontSize: "24px",
    textAlign: "center",
    boxShadow: "4px 4px 8px 0px rgba(0, 0, 0, 0.25)",
    marginBottom: "8px",
  },
  cardHeading: { color: "#393939", fontWeight: 600, fontSize: "18px" },
};
